import { render, staticRenderFns } from "./TaskDetailSidebar.vue?vue&type=template&id=e6cfd7da&scoped=true"
import script from "./TaskDetailSidebar.vue?vue&type=script&lang=js"
export * from "./TaskDetailSidebar.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailSidebar.vue?vue&type=style&index=0&id=e6cfd7da&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cfd7da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6cfd7da')) {
      api.createRecord('e6cfd7da', component.options)
    } else {
      api.reload('e6cfd7da', component.options)
    }
    module.hot.accept("./TaskDetailSidebar.vue?vue&type=template&id=e6cfd7da&scoped=true", function () {
      api.rerender('e6cfd7da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/tasks/TaskDetailSidebar.vue"
export default component.exports